var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"notifications",attrs:{"tag":"div","name":"notification-list"}},_vm._l((_vm.notifications),function(item){return _c('notification-item',{key:item.id,staticClass:"notification-item",attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }